module.exports = __webpack_public_path__ + "0fdbab4b7079813088667d1aaf0d47ce.jpg";